import { getBrowserType, getDeviceTypeAkamai } from "../../../../common/utils";
import { getPageType, getPlayerType } from "../../../lib/analytics/utils";

export function isElementInViewport(el, ratio = 1.0, lookLeftAndRight = false) {
  if (!(el instanceof HTMLElement)) return null;

  const rect = el.getBoundingClientRect();
  return (
    rect.top + el.offsetHeight * ratio >= 0 &&
    rect.bottom - el.offsetHeight * ratio <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    (lookLeftAndRight ? rect.left >= 0 : true) &&
    (lookLeftAndRight
      ? rect.right <=
        (window.innerWidth || document.documentElement.clientWidth)
      : true)
  );
}

export const getCommonSplunkData = (eventType, config) => {
  return {
    eventType,
    userAgent: window.navigator.userAgent,
    browserType: getBrowserType(),
    deviceType: getDeviceTypeAkamai(),
    href: window.location.href,
    hostname: window.location.host,
    pageType: getPageType(),
    playerType: getPlayerType(config),
    player: "orca"
  };
};
